const adminSessionExpiredEvent = 'admin-session-expired'
const adminSessionEvents = new EventTarget()

export function emitAdminSessionExpired(): void {
  adminSessionEvents.dispatchEvent(new Event(adminSessionExpiredEvent))
}

export function subscribeToAdminSessionExpired(listener: () => void): () => void {
  adminSessionEvents.addEventListener(adminSessionExpiredEvent, listener)
  return () => adminSessionEvents.removeEventListener(adminSessionExpiredEvent, listener)
}
